<script setup lang="ts">
import GhostButton from '@/components/common/GhostButton.vue';
import PrimaryButton from '@/components/common/PrimaryButton.vue';
import { useAuthStore } from '@/stores/auth.store';

const authStore = useAuthStore();

const { t } = useTranslations();
</script>

<template>
  <div class="text-center">
    <p class="text-base font-semibold text-brand-primary">404</p>
    <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
      {{ t('not_found.title') }}
    </h1>
    <p class="mt-6 text-base leading-7 text-gray-600">
      {{ t('not_found.description') }}
    </p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <router-link v-if="authStore.access_token" :to="{ name: 'DashboardView' }">
        <PrimaryButton> {{ t('not_found.back_to_dashboard') }} </PrimaryButton>
      </router-link>
      <router-link v-else :to="{ name: 'AuthLoginView' }">
        <PrimaryButton> {{ t('not_found.back_to_login') }} </PrimaryButton>
      </router-link>
      <router-link :to="{ name: 'AuthLoginView' }">
        <GhostButton> {{ t('not_found.contact_support') }} </GhostButton>
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
